import styled from "styled-components/macro";

import type { ThemeProps as Props } from "models/styles/theme";
import { CssFlex } from "styles/helpers/layout";

export const StyledPageContainer = styled(CssFlex)<Props>`
  min-height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 3rem;
  background-color: ${(props: Props) => props.theme.palette.secondary._900};
  background: linear-gradient(180deg, ${(props: Props) => props.theme.palette.neutral.white} 0%, ${(props: Props) => props.theme.palette.secondary._900} 50%);
`;

export const StyledContentContainer = styled(CssFlex)<Props>`
  padding: 3rem;
  width: 30rem;
  max-width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 2rem;
  border-radius: 1rem;
  box-shadow: 0px 8px 10px 1px #11111112;
  background-color: ${(props: Props) => props.theme.palette.neutral.white};
  text-align: center;
`;

export const StyledLicenseInfoBox = styled(CssFlex)<Props>`
  width: 100%;
  padding: 1.5rem;
  border-radius: 1rem;
  flex-direction: column;
  row-gap: 1rem;
  background-color: ${(props: Props) => props.theme.palette.neutral._950};
`;

export const StyledMetadataRow = styled(CssFlex)<Props>`
  column-gap: 1rem;
  justify-content: space-between;

  color: ${(props: Props) => props.theme.palette.neutral._300};

  span {
    color: ${(props: Props) => props.theme.palette.neutral.black};
  }
`;
